// components/ui/IconsList/IconsList.jsx
import { getIconsByPreset } from "../../../data/icons";
import s from "./IconsList.module.scss";

// Если у тебя есть свой компонент иконок — подключай его сюда
// import SvgIcon from "../SvgIcon/SvgIcon";

function IconsList({ preset = "header", className = "", itemClassName = "" }) {
  const icons = getIconsByPreset(preset);

  if (!icons.length) return null;

  return (
    <div className={`${s.list} ${className}`}>
     {icons.map((x) => {
        const Icon = x.Icon; // <-- React-компонент

        return (
          <a
            key={x.id}
            href={x.href}
            className={`${s.item} ${itemClassName}`}
            target={x.href?.startsWith("http") ? "_blank" : undefined}
            rel={x.href?.startsWith("http") ? "noreferrer" : undefined}
            aria-label={x.label}
            title={x.label}
          >
            <Icon className={s.icon} />
          </a>
        );
      })}
    </div>
  );
}

export default IconsList;
